import React, { useEffect, useState } from "react";
import { SecondaryButton, ErrorBanner, EmptyState } from "./ui";
import { getUserBookings } from "../api/poojaApi";

const STATUS_LABELS = {
  pending: "Payment Pending",
  confirmed: "Confirmed",
  completed: "Completed",
  cancelled: "Cancelled",
  refunded: "Refunded",
};

const STATUS_COLORS = {
  pending: "#b45309",
  confirmed: "#3f7a4f",
  completed: "#1d4ed8",
  cancelled: "#b3402f",
  refunded: "#6b5c4d",
};

export default function PoojaBookingHistory({ onBack }) {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    getUserBookings()
      .then((res) => setBookings(res.data || []))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={styles.wrap}>
      <SecondaryButton onClick={onBack}>← Back to Poojas</SecondaryButton>

      <h2 style={styles.heading}>My Pooja Bookings</h2>

      {loading && <div style={styles.loading}>Loading your bookings…</div>}
      <ErrorBanner message={error} />

      {!loading && !error && bookings.length === 0 && (
        <EmptyState>You haven't booked any pooja yet.</EmptyState>
      )}

      <div style={styles.list}>
        {bookings.map((b) => (
          <div key={b.id} style={styles.card}>
            <div style={styles.cardTop}>
              <span style={styles.poojaTitle}>{b.pooja_title}</span>
              <span
                style={{
                  ...styles.statusBadge,
                  background: STATUS_COLORS[b.status] || "var(--ink-soft)",
                }}
              >
                {STATUS_LABELS[b.status] || b.status}
              </span>
            </div>
            {b.astrologer_name && (
              <div style={styles.row}>Astrologer: {b.astrologer_name}</div>
            )}
            <div style={styles.row}>Total paid: ₹{b.total_paid}</div>
            <div style={styles.row}>
              Booked on: {new Date(b.booked_at).toLocaleDateString()}
            </div>
            {b.status === "confirmed" && b.meeting_link && (
              <a
                href={b.meeting_link.replace(/^https?:\/\/[^/]+/, window.location.origin)}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.joinBtn}
              >
                🎥 Join Video Call
              </a>
            )}
            {b.session_summary && (
              <div style={styles.summary}>📝 {b.session_summary}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  wrap: { maxWidth: 720, margin: "0 auto" },
  heading: {
    fontFamily: "var(--font-serif)", fontSize: 22, margin: "16px 0", color: "var(--ink)",
  },
  loading: { textAlign: "center", color: "var(--ink-soft)", padding: "20px 0" },
  list: { display: "flex", flexDirection: "column", gap: 12 },
  card: {
    border: "1px solid var(--line)", borderRadius: "var(--radius)",
    background: "var(--card)", padding: "14px 16px",
  },
  cardTop: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
    marginBottom: 8, flexWrap: "wrap", gap: 8,
  },
  poojaTitle: { fontWeight: 700, fontSize: 15.5, color: "var(--ink)" },
  statusBadge: {
    color: "#fff", fontSize: 11, fontWeight: 700, padding: "3px 10px",
    borderRadius: 999, textTransform: "uppercase",
  },
  row: { fontSize: 13.5, color: "var(--ink-soft)", marginBottom: 4 },
  joinBtn: {
    display: "inline-flex", alignItems: "center", gap: 6,
    marginTop: 6, padding: "8px 16px", borderRadius: 999,
    background: "linear-gradient(135deg, var(--terracotta), var(--terracotta-dark))",
    color: "#fff", fontWeight: 700, fontSize: 13, textDecoration: "none",
  },
  summary: { fontSize: 13.5, color: "var(--ink)", marginTop: 8, lineHeight: 1.5 },
};